import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as style from './styles';

// Headings
export const H1 = styled.h1(style.heading1);
export const H2 = styled.h2(style.heading2);
export const H3 = styled.h3(style.heading3);
export const H4 = styled.h4(style.heading4);

// Body
export const Body1 = styled.p(style.body1);
export const Body2 = styled.p(style.body2);
export const Body1Medium = styled.p(style.body1Medium);
export const Body2Medium = styled.p(style.body2Medium);
export const Body1Bold = styled.p(style.body1Bold);
export const Body2Bold = styled.p(style.body2Bold);
export const BoldText = styled.b`
  font-weight: ${style.fontWeights.bold};
`;

// Links
export const WebLink = styled.a`
  ${style.link}
`;
export const WebLink2 = styled.a`
  ${style.link2}
`;

export const RouterLink = styled(Link)`
  ${style.link}
`;
export const RouterLink2 = styled(Link)`
  ${style.link2}
`;

// Monospace
export const Monospace1 = styled.code(style.monospace1);
export const Monospace2 = styled.code(style.monospace2);
export const Code = styled.code(style.code);

// Buttons
export const ButtonBase = styled.button(style.button);

// Subtitles
export const Subtitle1 = styled.h5(style.subtitle1);
export const Subtitle2 = styled.h6(style.subtitle2);

// Other
export const Caption = styled.span(style.caption);
export const Overline = styled.span(style.overline);

export const Label = styled.label`
  ${style.label}
`;
